module.exports = require("./qu-BO.js");